import { AbstractDialogContent } from '../../../../abstracts/dialog/dialog-content';
import { Component, Injector, Input, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ModelsService } from '@services/entity/models.services';
import { DEDatePipe } from '../../../../pipes/de-date.pipe';
import { FormService } from '@services/form/form.service';
import { FormControl, FormGroup, UntypedFormGroup, Validators, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { ModelDto } from '../../../../dto/modelDto';
import { ToastService } from '../../../../services/toast/toast.service';

@Component({
  selector: 'app-edit-chargingstationprofile-dialog-content',
  templateUrl: './edit-chargingstationprofile-dialog-content.component.html',
  styleUrls: ['./edit-chargingstationprofile-dialog-content.component.scss']
})
export class EditChargingstationProfileDialogContentComponent extends AbstractDialogContent implements OnInit {
  public className: 'EditChargingStationProfileDialogContentComponent';

  datestring: string;
  public form: UntypedFormGroup;
  public formCreated: boolean;

  constructor(
    public activeModal: NgbActiveModal,
    private activatedRoute: ActivatedRoute,
    private modelsService: ModelsService,
    private toastService: ToastService,
    injector: Injector
  ) {
    super(activeModal, injector);
  }

  public modell: ModelDto;
  public date;
  public datetimeLocal;
  public profileId;
  public customerId;


  
  ngOnInit(): void {
    this.modelsService.getModel(this.profileId.key).subscribe(model => {
      this.modell = model;
      this.createForm();
    }, error => { })
  }

  initialize() {
    let intDate = new Date(this.modell.integrationDate).toUTCString();
    this.datetimeLocal = this.formatDateToDatetimeLocal(intDate);
    this.date = this.datetimeLocal;
  }

  formatDateToDatetimeLocal(date: string): string {
    const utcDate = new Date(date);
    const year = utcDate.getFullYear();
    const month = String(utcDate.getMonth() + 1).padStart(2, '0');
    const day = String(utcDate.getDate()).padStart(2, '0');
    const hours = String(utcDate.getHours()).padStart(2, '0');
    const minutes = String(utcDate.getMinutes()).padStart(2, '0');

    return `${year}-${month}-${day}T${hours}:${minutes}`;
  }

  createForm() {

    this.form = new UntypedFormGroup({
      manufacturerId: new UntypedFormControl(this.modell.manufacturerId),
      manufacturerName: new UntypedFormControl(this.modell.manufacturer.name),
      modelname: new UntypedFormControl(this.modell.name),
      pictureUri: new UntypedFormControl(this.modell.pictureUri),
      isErk: new UntypedFormControl(this.modell.profile.isErk),
      numberOfConnectors: new UntypedFormControl(this.modell.profile.numberOfConnectors),
      isOcpp16: new UntypedFormControl(this.modell.profile.isOcpp16),
      isOcpp20: new UntypedFormControl(this.modell.profile.isOcpp20),
      isOcpp201: new UntypedFormControl(this.modell.profile.isOcpp201),
      isUpdatable: new UntypedFormControl(this.modell.profile.isUpdatable),
      isMobile: new UntypedFormControl(this.modell.profile.isMobile),
      isAc: new UntypedFormControl(this.modell.profile.isAc),
      isDc: new UntypedFormControl(this.modell.profile.isDc),
      isPnc: new UntypedFormControl(this.modell.profile.isPnc),
      isBidi: new UntypedFormControl(this.modell.profile.isBidi),
    });
    this.formCreated = true;
  }

  onSubmit(formValue) {
    this.modell.manufacturer.name = formValue['manufacturerName']
    this.modell.name = formValue['modelname'];
    this.modell.profile.isErk = formValue['isErk'];
    this.modell.profile.isOcpp16 = formValue['isOcpp16'];
    this.modell.profile.isOcpp20 = formValue['isOcpp20'];
    this.modell.profile.isOcpp201 = formValue['isOcpp201'];
    this.modell.profile.isUpdatable = formValue['isUpdatable'];
    this.modell.profile.isMobile = formValue['isMobile'];
    this.modell.profile.isPnc = formValue['isPnc'];
    this.modell.profile.isAc = formValue['isAc'];
    this.modell.profile.isDc = formValue['isDc'];
    this.modell.profile.isBidi = formValue['isBidi'];
    this.modell.profile.numberOfConnectors = formValue['numberOfConnectors'];
    this.modell.integrationDate = formValue['integrationDate'];

    this.modelsService.patchModel(this.modell).subscribe(res => {
      if (res) {
        this.toastService.success('Profil wurde erfolgreich gespeichert', 3000, true);
        this.activeModal.dismiss();

      } else {
        this.toastService.error('Profil konnte nicht gespeichert werden', 3000, true);

      }
    })
  }


  public onCancelClick(): void {
    this.activeModal.dismiss();
  }

}
